// extracted by mini-css-extract-plugin
export default {"dropZone":"style_dropZone__-TAbe","uploadBtn":"style_uploadBtn__BUgXU"};